// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-pages----404-module---wrapper---P1LDU","image":"src-pages----404-module---image---3jRBY","heading":"src-pages----404-module---heading---1S2uI","button":"src-pages----404-module---button---16zuU","spinAround":"src-pages----404-module---spinAround---2e0HD"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/404.module.scss
// module id = 458
// module chunks = 162898551421021